import { render, staticRenderFns } from "./templateProductSizeDetail.vue?vue&type=template&id=13a2ce17&scoped=true"
import script from "./templateProductSizeDetail.vue?vue&type=script&lang=js"
export * from "./templateProductSizeDetail.vue?vue&type=script&lang=js"
import style0 from "./templateProductSizeDetail.vue?vue&type=style&index=0&id=13a2ce17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a2ce17",
  null
  
)

export default component.exports